import { Typography, TypographyVariant } from "@mui/material";

function LoadingSpan(props: { variant?: TypographyVariant }) {
  const { variant } = props;

  return (
    <Typography
      component="span"
      variant={variant}
      style={{
        textDecoration: "underline",
        textDecorationStyle: "dotted",
        fontWeight: "bold",
      }}
    >
      loading
    </Typography>
  );
}

export default LoadingSpan;
